<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar :user="user" @menu-toggle="onMenuToggle"/>
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <slot/>
            </div>
            <AppFooter/>
        </div>

        <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
        <Toast/>
    </div>
</template>

<script>
import axios from 'axios';
import Toast from 'primevue/toast';
import AppConfig from '../Components/AppConfig.vue';
import AppFooter from '../Components/AppFooter.vue';
import AppMenu from '../Components/AppMenu.vue';
import AppTopBar from '../Components/AppTopbar.vue';

export default {
    data() {
        return {
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu: [],
            user: [],
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    async created (){
        if(!sessionStorage.getItem('auth:me')) {
            await this.getUser()
        }

    },
    async mounted(){
        await this.$nextTick();
        if(sessionStorage.getItem('auth:me')) {
            this.getMenu()
        }
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                } else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            } else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },
        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        getUser() {
            axios.get(this.route('api.auth.me'))
            .then((data) => {
                sessionStorage.setItem('auth:me', JSON.stringify(data.data.data.data))
            })
            .catch((err) => {
                console.log(err)
            }).finally(() => {
                this.getMenu()
            })
        },
        getMenu() {
            let getUser = JSON.parse(sessionStorage.getItem('auth:me'));
            let menu = [];
            this.user = getUser;

            if(getUser.roles == 'user') {
                menu = [
                    {
                    label: 'Menu',
                    items: [
                        {
                            label: this.$i18n.t('summary-employee-attendance'), icon: 'pi pi-fw pi-home',  to: this.route('attendance.views.summary.user'),
                        },
                        {
                            label: this.$i18n.t('attendances'), icon: 'pi pi-fw pi-calendar-times',
                            items: [
                                {label: this.$i18n.t('employee-attendance'),  to: `${this.$page.props.appUrl}attendance-views/create`},
                                {label: "Rekap Kehadiran",  to: `${this.$page.props.appUrl}attendance-views`},
                            ],
                        },
                        {
                            label: "Patroli", icon: 'pi pi-fw pi-camera',
                            items: [
                                {label: "Checkin", to: `${this.$page.props.appUrl}patrol-checkins`},
                                {label: "Riwayat Patroli", to: `${this.$page.props.appUrl}patrol-checkin-history`},
                            ]
                        },
                        {
                            label: "Tukar Shift", icon: 'pi pi-fw pi-user', to: `${this.$page.props.appUrl}user/change-shift`
                        },
                        {
                            label: this.$i18n.t('Vacation'), icon: 'pi pi-fw pi-sun', to: this.route('vacations'), prefix: 'Vacation'
                        },
                        {
                            label: this.$i18n.t('Overtime'), icon: 'pi pi-fw pi-clock', to: this.route('overtime.user'), prefix: 'Vacation'
                        },
                        {
                            label: this.$i18n.t('sign-out'), icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                                sessionStorage.removeItem('auth:me')
                            },
                        }]
                },
                ]
                this.menu = menu
                return;
            }
            if(getUser.roles == 'client'){
                menu = [
                {
                    label: 'Menu',
                    items: [
                        {label: this.$i18n.t('dashboard'), icon: 'pi pi-fw pi-home', to: this.route('dashboard.client'), prefix: 'dashboard'},
                        {
                            label: this.$i18n.t('attendances'), icon: 'pi pi-fw pi-calendar-times',
                            items: [
                                // {label: this.$i18n.t('summary-employee-attendance'),  to: `${this.$page.props.appUrl}attendance/summary`},
                                {label: 'Rekap Data Kehadiran',  to: `${this.$page.props.appUrl}attendance`},
                            ],
                        },
                        {
                            label: "Patroli", icon: 'pi pi-fw pi-camera',
                            items: [
                                // {label: 'Poin Patroli', to: `${this.$page.props.appUrl}admin/patrol-point`},
                                {label: "Riwayat Patroli", to: `${this.$page.props.appUrl}admin/summary-checkin`},
                            ]
                        },
                        {
                            label: this.$i18n.t('sign-out'), icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                                sessionStorage.removeItem('auth:me')
                            },
                        }]
                },
            ]
                this.menu = menu;
                return;
            }
            menu = [
                {
                    label: 'Menu',
                    items: [
                        {label: this.$i18n.t('dashboard'), icon: 'pi pi-fw pi-home', to: this.route('dashboard'), prefix: 'dashboard'},
                        {
                            label: 'Master Data', icon: 'pi pi-fw pi-cog',
                            items: [
                                {label: this.$i18n.t('nationalities') , to: this.route('nationalities')},
                                {label: this.$i18n.t('education'), to: this.route('education-levels')},
                                {label: this.$i18n.t('team'), to: this.route('teams')},
                                {label: this.$i18n.t('position'), to: this.route('positions')},
                                {label: this.$i18n.t('division'), to: this.route('divisions')},
                                {label: this.$i18n.t('placement-unit'), to: this.route('placement-units')},
                                {label: this.$i18n.t('bank'), to: this.route('banks')},
                                {label: this.$i18n.t('position-class'), to: this.route('position-classes')},
                                {label: this.$i18n.t('training'), to: this.route('trainings')},
                                {label: 'Shift', to: this.route('shifts')},
                                {label: 'Cuti', to: this.route('master-vacations')},
                            ]
                        },
                        {
                            label: this.$i18n.t('recruitment'), icon: 'pi pi-fw pi-users',
                            items: [
                                {label: this.$i18n.t('vacancy'), to: this.route('vacancies')},
                                {label: this.$i18n.t('list-candidate'), to: this.route('candidates.index')},
                                {label: this.$i18n.t('selection-candidate'),
                                    items: [
                                        {label: this.$i18n.t('psikotest'),  to: this.route('candidate-psikotests.index')},
                                        {label: this.$i18n.t('orientation'),  to: this.route('candidate-orientations.index')},
                                        {label: this.$i18n.t('training'),  to: this.route('candidate-trainings.index')},
                                    ]
                                },
                            ],
                        },
                        {
                            label: this.$i18n.t('employee'), icon: 'pi pi-fw pi-users',
                            items: [
                                {label: this.$i18n.t('manage-employee'), to: this.route('employee-views.index')},
                                {label: this.$i18n.t('entry-kpi'), to: `${this.$page.props.appUrl}employee-view-assessements`},
                                // {label: "Plafon Karyawan", to: this.route('comingsoon')},
                                // {label: this.$i18n.t('employee-history'), to: this.route('comingsoon')},
                                {label: this.$i18n.t('employee-potention-test'),  to: `${this.$page.props.appUrl}employee-potential-test-views/create`},
                                {label: this.$i18n.t('report') + " " + this.$i18n.t('employee-potention-test'),  to: `${this.$page.props.appUrl}employee-potential-test-views`},
                                // {label: this.$i18n.t('blacklist'), to: this.route('comingsoon')},
                            ],
                        },
                        {
                            label: this.$i18n.t('attendances'), icon: 'pi pi-fw pi-calendar-times',
                            items: [
                                {label: this.$i18n.t('summary-employee-attendance'),  to: `${this.$page.props.appUrl}attendance/summary`},
                                {label: 'Rekap Data Kehadiran',  to: `${this.$page.props.appUrl}attendance`},
                                {label: 'Pengajuan Cuti',  to: `${this.$page.props.appUrl}vacation-apply`},
                                {label: 'Tukar Shift', to: `${this.$page.props.appUrl}admin/change-shift`},
                            ],
                        },
                        {
                            label: "Patroli", icon: 'pi pi-fw pi-camera',
                            items: [
                                {label: 'Poin Patroli', to: `${this.$page.props.appUrl}admin/patrol-point`},
                                {label: "Riwayat Patroli", to: `${this.$page.props.appUrl}admin/summary-checkin`},
                            ]
                        },
                        {
                            label: this.$i18n.t('payroll'), icon: 'pi pi-fw pi-money-bill',
                            items: [
                                {label: this.$i18n.t('entry-payroll'), to: `${this.$page.props.appUrl}payrolls/create`},
                                {label: this.$i18n.t('manage-payroll'), to: `${this.$page.props.appUrl}payrolls/`},
                                // {label: this.$i18n.t('report-payroll'),
                                // items: [
                                //     // {label: "Cut Off", to: this.route('comingsoon')},
                                //     {label: this.$i18n.t('per-period'), to: this.route('comingsoon')},
                                //     {label: this.$i18n.t('per-month'), to: this.route('comingsoon')},
                                //     {label: this.$i18n.t('per-year'), to: this.route('comingsoon')},
                                //     // {label: "Rekap Gaji dan BPJS", to: this.route('comingsoon')},
                                //     // {label: "Per Bank", to: this.route('comingsoon')},
                                //     // {label: "Daftar Gaji [THR]", to: this.route('comingsoon')}
                                // ]},
                            ],
                        },
                        {
                            label: this.$i18n.t('invoice'), icon: 'pi pi-fw pi-book',
                            items: [
                                {label: this.$i18n.t('create-invoice'), to: `${this.$page.props.appUrl}invoice-views/create`},
                                {label: this.$i18n.t('manage-invoice'), to: `${this.$page.props.appUrl}invoice-views`},
                                {label: "Management Fee[Setelah Proses Payroll]"},
                            ],
                        },
                        {
                            label: this.$i18n.t('letter') + ' dan ' + this.$i18n.t('agreement'), icon: 'pi pi-fw pi-file-o', items: [
                                {label: "Entry Surat Penugasan", to: `${this.$page.props.appUrl}letter/instructions`},
                                {label: "Entry Surat Peringatan", to: `${this.$page.props.appUrl}letter/warnings`},
                                {label: "Entry PKWT", to:`${this.$page.props.appUrl}letter/contracts`},
                                // {label: "Cetak Surat & Perjanjian", items:[
                                //     {label: "Semua", to: this.route('comingsoon')},
                                //     {label: "Pengantar Kontrak", to: this.route('comingsoon')},
                                //     {label: "Pengantar Medical Check-up", to: this.route('comingsoon')},
                                //     {label: "Pengantar Orientasi", to: this.route('comingsoon')},
                                //     {label: "Pengantar Training", to: this.route('comingsoon')},
                                //     {label: "Pengantar Wawancara", to: this.route('comingsoon')},
                                //     {label: "Perjanjian Kerja Waktu Tertentu [PKWT]", to: this.route('comingsoon')},
                                //     {label: "Surat Perjanjian Program Training / Pelatihan", to: this.route('comingsoon')},
                                //     {label: "Surat Keterangan Pengalaman Kerja", to: this.route('comingsoon')},
                                //     {label: "Surat Keterangan Jamsostek", to: this.route('comingsoon')},
                                //     {label: "Surat Peringatan", to: this.route('comingsoon')},
                                //     {label: "Surat Pernyataan [Lampiran Surat Peringatan]", to: this.route('comingsoon')},
                                // ]},
                            ],
                        },
                        {
                            label: this.$i18n.t('print-form'), icon: 'pi pi-fw pi-print', items: [
                                {label: "Surat Keterangan Pengalaman Kerja", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/bpjs`, "Form Paklaring.pdf");
                                }},
                                {label: "Surat Perbaikan BPJS", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/bpjs`,'Form Perbaikan BPJS.pdf');
                                }},
                                {label: "Surat Peringatan", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/warning`,'Surat Peringatan.pdf');
                                }},
                                {label: "Surat Pernyataan Umum", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/general`,'Surat Pernyataan Umum');
                                }},
                                {label: "Surat Keterangan Pembuatan Rekening", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/bank`,'Surat Keterangan Pembuatan Rekening');
                                }},
                                {label: "Surat Perintah Tugas", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/assignment`,'Surat Perintah Tugas');
                                }},
                                {label: "KPI", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/kpi`,'Form KPI');
                                }},
                                {label: "PKWT", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/pkwt`,'PKWT');
                                }},
                                {label: "Data Tes Bimbingan Jasmani", command: () => {
                                    this.exportPdf(`${this.$page.props.appUrl}api/forms/physical`, "Data Tes Bimbingan Jasmani.pdf");
                                }},
                            ],
                        },
                        {
                            label: this.$i18n.t('user'), icon: 'pi pi-fw pi-users',
                            items : [
                                {label: 'Users', to: this.route('users')},
                                {label: 'Roles', to: this.route('roles')},
                                {label: 'Permissions', to: this.route('permissions')},
                            ]
                        },
                        {
                            label: this.$i18n.t('sign-out'), icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                                sessionStorage.removeItem('auth:me')
                            },
                        }]
                },
            ]

            this.menu = menu
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        },
        exportPdf(url, filename){
            axios({
                method: 'get',
                url: url,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download',filename);
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Form Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppFooter': AppFooter,
        'AppConfig': AppConfig,
        Toast,
    }
}
</script>
